/**
 * Converts seconds to hh:mm:ss
 *
 * @param {number} seconds
 *
 * @return {string}
 */
export default function formatSeconds (seconds, showHours = false) {
  const negative = seconds < 0;

  seconds = Math.abs(seconds);

  const ss = `${(seconds % 60) | 0}`.padStart(2, '0');
  const mm = `${((seconds / 60) % 60) | 0}`.padStart(2, '0');
  const hh = ((seconds / 3600) % 3600) | 0;

  if (showHours || hh > 0) {
    return negative ? `-${hh}:${mm}:${ss}` : `${hh}:${mm}:${ss}`;
  }

  return negative ? `-${mm}:${ss}` : `${mm}:${ss}`;
}
